import React from 'react';
import { Box, Button, Flex, Icon, icons, Menu, MenuButton, MenuItem, MenuList } from '@tapresearch/ui/components';
import moment from 'moment';
import { Link } from 'react-router-dom';
import useAsset from '../../../hook/useAsset';
export var QuestionSingleWaveSelect = function(param) {
    var waves = param.waves, projectIdentifier = param.projectIdentifier;
    var constants = useAsset().constants;
    return /*#__PURE__*/ React.createElement(Menu, {
        isLazy: true,
        autoSelect: false
    }, /*#__PURE__*/ React.createElement(MenuButton, {
        as: Button,
        "data-testid": "question-single-wave-select-trigger",
        variant: "ghost",
        fontWeight: "semibold",
        colorScheme: "blue",
        color: "blue.500",
        rightIcon: /*#__PURE__*/ React.createElement(Icon, {
            icon: icons.fi.ChevronDown
        })
    }, "Select wave"), /*#__PURE__*/ React.createElement(MenuList, {
        "data-testid": "question-single-wave-select-menu",
        py: 2,
        px: 1,
        maxH: '300px',
        minW: '180px',
        overflowY: 'scroll'
    }, waves.map(function(wave) {
        if (wave.attributes.status === constants.STATUS_DRAFT) return null;
        return /*#__PURE__*/ React.createElement(SingleWaveMenuItem, {
            key: wave.attributes.identifier,
            wave: wave,
            projectIdentifier: projectIdentifier
        });
    })));
};
var SingleWaveMenuItem = function(param) {
    var wave = param.wave, projectIdentifier = param.projectIdentifier;
    return /*#__PURE__*/ React.createElement(MenuItem, {
        "data-testid": "single-wave-menu-item",
        as: Link,
        to: "/projects/".concat(projectIdentifier, "/campaigns/").concat(wave.attributes.identifier),
        target: '_blank',
        rel: 'noopener noreferrer',
        rounded: 'md',
        fontSize: 'sm',
        color: 'gray.600',
        mb: 1,
        py: 2,
        transitionProperty: 'common',
        transitionDuration: 'normal',
        _hover: {
            bg: 'blue.100'
        }
    }, /*#__PURE__*/ React.createElement(Flex, {
        sx: {
            lineHeight: 1
        },
        w: "full",
        justify: "space-between",
        align: "center"
    }, /*#__PURE__*/ React.createElement(Flex, null, "Wave ", wave.attributes.wave_number), /*#__PURE__*/ React.createElement(Flex, null, "".concat(moment(wave.attributes.launch_date).format('M/D')), /*#__PURE__*/ React.createElement(Icon, {
        wrapAs: Box,
        boxSize: 4,
        ml: 4,
        icon: icons.io4.MdOpen
    }))));
};
